module.exports = {
	...require('wsm-common-data')
};
